/**
 * Upload Validator Utility
 * Validates files before uploading to backend
 */

const MAX_FILE_SIZE_MB = parseInt(process.env.REACT_APP_MAX_UPLOAD_FILE_SIZE_MB || '10');
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Validate all selected files
 * @param {FileList|File[]} files - Files to validate
 * @returns {Object} { valid: boolean, errors: string[] }
 */
export const validateFiles = (files) => {
    const errors = [];

    if (!files || files.length === 0) {
        return { valid: true, errors: [] };
    }

    Array.from(files).forEach((file) => {
        // Check file size
        if (file.size > MAX_FILE_SIZE_BYTES) {
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
            errors.push(`"${file.name}" is ${fileSizeMB}MB (max ${MAX_FILE_SIZE_MB}MB)`);
        }
    });

    return {
        valid: errors.length === 0,
        errors
    };
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted size (e.g., "2.5 MB")
 */
export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

/**
 * Get file extension
 * @param {string} filename - File name
 * @returns {string} File extension (e.g., "pdf")
 */
export const getFileExtension = (filename) => {
    return filename.split('.').pop().toLowerCase();
};

/**
 * Get file type color based on extension
 * @param {string} extension - File extension
 * @returns {string} Color hex code
 */
export const getFileTypeColor = (extension) => {
    const colorMap = {
        pdf: '#dc2626',
        doc: '#2b579a',
        docx: '#2b579a',
        xls: '#217346',
        xlsx: '#217346',
        csv: '#217346',
        jpg: '#e67e22',
        jpeg: '#e67e22',
        png: '#e67e22',
        svg: '#e67e22',
        gif: '#e67e22',
        txt: '#7f8c8d',
        rtf: '#7f8c8d',
        zip: '#8e44ad',
        rar: '#8e44ad',
        '7z': '#8e44ad',
    };

    return colorMap[extension] || '#0c5097';
};

export const MAX_FILE_SIZE_CONFIG = {
    bytes: MAX_FILE_SIZE_BYTES,
    mb: MAX_FILE_SIZE_MB
};
